import { render, staticRenderFns } from "./PropertiesView.vue?vue&type=template&id=2df6a82b&scoped=true&"
import script from "./PropertiesView.vue?vue&type=script&lang=js&"
export * from "./PropertiesView.vue?vue&type=script&lang=js&"
import style0 from "./PropertiesView.vue?vue&type=style&index=0&id=2df6a82b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df6a82b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2df6a82b')) {
      api.createRecord('2df6a82b', component.options)
    } else {
      api.reload('2df6a82b', component.options)
    }
    module.hot.accept("./PropertiesView.vue?vue&type=template&id=2df6a82b&scoped=true&", function () {
      api.rerender('2df6a82b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/PropertiesView.vue"
export default component.exports